/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react";
import PropTypes from "prop-types";
import { Script } from "gatsby";
import Header from "./header";
import Footer from "./footer";
import "../scss/index.scss";

const Layout = ({ children, blog, dark }) => {
  //const [jqueryLoaded, setJqueryLoaded] = React.useState(false);
  //const [popupLoaded, set] = React.useState(false);
  // const location = useLocation();
  const ref = React.useRef();
  // const [firstUpdate, setFirstUpdate] = React.useState(true)
  // React.useLayoutEffect(() => {
  //   console.log('d update', firstUpdate)
  //   if(!firstUpdate && location.hash) {
  //     console.log('called scroll',location.hash,  ref?.current?.querySelector(location.hash).offsetTop)
  //       console.log(Array.from(ref?.current?.querySelectorAll('section')).map(e => e.offsetTop))

  //       window.scrollTo({top: ref?.current?.querySelector(location.hash)?.offsetTop})
  //   }
  //   setFirstUpdate(false)
  // }, [firstUpdate])

  return (
    <>
      <Script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        charset="UTF-8"
        data-domain-script="d217321a-c0ea-478d-8181-c42fa6610ce1"
      ></Script>
      <Script type="text/javascript">{`function OptanonWrapper() { }`}</Script>
      <Header blog={blog} dark={dark} />
      <main ref={ref}>{children}</main>
      <Footer />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  blog: PropTypes.bool,
};

export default Layout;
